import { StyledTelegramPost as TelegramPost } from '../../../components/TelegramPost.jsx';

export const mapTelegramPlaceholderToTelegramComponent = matchedElem => {
  const { id, single } = matchedElem.dataset;

  return (
    <TelegramPost telegramPostId={id} isSinglePicture={single}/>
  );
};
